import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-visor" }
const _hoisted_2 = { class: "visor-header" }
const _hoisted_3 = { class: "visor-titulo" }
const _hoisted_4 = { class: "visor-sub" }
const _hoisted_5 = { class: "visor-cuerpo" }
const _hoisted_6 = { class: "visor-pie" }

import { computed } from 'vue'
import type { CriterioEvaluacion } from '@/interfaces/CriterioEvaluacion'
import RubricaTabla from '@/components/RubricaTabla.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'RubricaVisorModal',
  props: {
    visible: { type: Boolean },
    criterio: {},
    nombreTipoComponente: {}
  },
  emits: ["cerrar"],
  setup(__props: any) {

/**
 * Visor de una rúbrica en modo consulta.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props



const rubrica = computed(() => props.criterio?.criterio ?? null)

const titulo = computed(() => {
  switch (props.criterio?.tipo_informacion) {
    case 'documental': return 'Criterios de Evaluación de la Información Documental'
    case 'cuantitativa': return 'Criterios de Evaluación de la Información Cuantitativa'
    case 'opinion': return 'Criterios de Evaluación de la Información de Opinión'
    default: return 'Rúbrica'
  }
})

const subtitulo = computed(() => {
  switch (props.criterio?.tipo_informacion) {
    case 'documental': return 'Ficha de revisión documental'
    case 'cuantitativa': return 'Ficha de revisión de indicadores estadísticos'
    case 'opinion': return 'Tabla de valoración'
    default: return props.nombreTipoComponente ?? ''
  }
})


return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "overlay-modal",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('cerrar')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_3, _toDisplayString(titulo.value), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(subtitulo.value), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-cerrar",
              title: "Cerrar",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cerrar')))
            }, "✕")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(RubricaTabla, { rubrica: rubrica.value }, null, 8, ["rubrica"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn salir",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cerrar')))
            }, "Cerrar")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})